/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var $__index_46_config__,
	    $__index_46_route__,
	    $__index_46_run__,
	    $__main_47_main_46_controller__,
	    $__detail_47_detail_46_controller__,
	    $___46__46__47_app_47_components_47_map_47_layers_46_service__,
	    $___46__46__47_app_47_components_47_oerebBern_47_oerebBern_46_service__,
	    $___46__46__47_app_47_components_47_extracts_47_extracts_46_service__,
	    $___46__46__47_app_47_components_47_notifications_47_notifications_46_service__,
	    $___46__46__47_app_47_components_47_coordinates_47_coordinates_46_service__,
	    $___46__46__47_app_47_components_47_loading_47_loading_46_service__,
	    $___46__46__47_app_47_components_47_helpers_47_helpers_46_service__,
	    $___46__46__47_app_47_components_47_map_47_map_46_service__,
	    $___46__46__47_app_47_components_47_map_47_map_46_directive__,
	    $___46__46__47_app_47_components_47_restriction_47_restriction_46_directive__,
	    $___46__46__47_app_47_components_47_notifications_47_notifications_46_directive__,
	    $___46__46__47_app_47_components_47_loading_47_loading_46_directive__,
	    $___46__46__47_app_47_components_47_search_47_searchSwisstopo_46_directive__,
	    $___46__46__47_app_47_components_47_backgroundImage_47_backgroundImage_46_directive__,
	    $___46__46__47_app_47_components_47_autofocus_47_autofocus_46_directive__;
	var config = ($__index_46_config__ = __webpack_require__(1), $__index_46_config__ && $__index_46_config__.__esModule && $__index_46_config__ || {default: $__index_46_config__}).config;
	var routerConfig = ($__index_46_route__ = __webpack_require__(2), $__index_46_route__ && $__index_46_route__.__esModule && $__index_46_route__ || {default: $__index_46_route__}).routerConfig;
	var runBlock = ($__index_46_run__ = __webpack_require__(3), $__index_46_run__ && $__index_46_run__.__esModule && $__index_46_run__ || {default: $__index_46_run__}).runBlock;
	var MainController = ($__main_47_main_46_controller__ = __webpack_require__(4), $__main_47_main_46_controller__ && $__main_47_main_46_controller__.__esModule && $__main_47_main_46_controller__ || {default: $__main_47_main_46_controller__}).MainController;
	var DetailController = ($__detail_47_detail_46_controller__ = __webpack_require__(5), $__detail_47_detail_46_controller__ && $__detail_47_detail_46_controller__.__esModule && $__detail_47_detail_46_controller__ || {default: $__detail_47_detail_46_controller__}).DetailController;
	var LayersService = ($___46__46__47_app_47_components_47_map_47_layers_46_service__ = __webpack_require__(6), $___46__46__47_app_47_components_47_map_47_layers_46_service__ && $___46__46__47_app_47_components_47_map_47_layers_46_service__.__esModule && $___46__46__47_app_47_components_47_map_47_layers_46_service__ || {default: $___46__46__47_app_47_components_47_map_47_layers_46_service__}).LayersService;
	var OerebBernService = ($___46__46__47_app_47_components_47_oerebBern_47_oerebBern_46_service__ = __webpack_require__(7), $___46__46__47_app_47_components_47_oerebBern_47_oerebBern_46_service__ && $___46__46__47_app_47_components_47_oerebBern_47_oerebBern_46_service__.__esModule && $___46__46__47_app_47_components_47_oerebBern_47_oerebBern_46_service__ || {default: $___46__46__47_app_47_components_47_oerebBern_47_oerebBern_46_service__}).OerebBernService;
	var ExtractsService = ($___46__46__47_app_47_components_47_extracts_47_extracts_46_service__ = __webpack_require__(8), $___46__46__47_app_47_components_47_extracts_47_extracts_46_service__ && $___46__46__47_app_47_components_47_extracts_47_extracts_46_service__.__esModule && $___46__46__47_app_47_components_47_extracts_47_extracts_46_service__ || {default: $___46__46__47_app_47_components_47_extracts_47_extracts_46_service__}).ExtractsService;
	var NotificationsService = ($___46__46__47_app_47_components_47_notifications_47_notifications_46_service__ = __webpack_require__(9), $___46__46__47_app_47_components_47_notifications_47_notifications_46_service__ && $___46__46__47_app_47_components_47_notifications_47_notifications_46_service__.__esModule && $___46__46__47_app_47_components_47_notifications_47_notifications_46_service__ || {default: $___46__46__47_app_47_components_47_notifications_47_notifications_46_service__}).NotificationsService;
	var CoordinatesService = ($___46__46__47_app_47_components_47_coordinates_47_coordinates_46_service__ = __webpack_require__(10), $___46__46__47_app_47_components_47_coordinates_47_coordinates_46_service__ && $___46__46__47_app_47_components_47_coordinates_47_coordinates_46_service__.__esModule && $___46__46__47_app_47_components_47_coordinates_47_coordinates_46_service__ || {default: $___46__46__47_app_47_components_47_coordinates_47_coordinates_46_service__}).CoordinatesService;
	var LoadingService = ($___46__46__47_app_47_components_47_loading_47_loading_46_service__ = __webpack_require__(11), $___46__46__47_app_47_components_47_loading_47_loading_46_service__ && $___46__46__47_app_47_components_47_loading_47_loading_46_service__.__esModule && $___46__46__47_app_47_components_47_loading_47_loading_46_service__ || {default: $___46__46__47_app_47_components_47_loading_47_loading_46_service__}).LoadingService;
	var HelpersService = ($___46__46__47_app_47_components_47_helpers_47_helpers_46_service__ = __webpack_require__(12), $___46__46__47_app_47_components_47_helpers_47_helpers_46_service__ && $___46__46__47_app_47_components_47_helpers_47_helpers_46_service__.__esModule && $___46__46__47_app_47_components_47_helpers_47_helpers_46_service__ || {default: $___46__46__47_app_47_components_47_helpers_47_helpers_46_service__}).HelpersService;
	var MapService = ($___46__46__47_app_47_components_47_map_47_map_46_service__ = __webpack_require__(13), $___46__46__47_app_47_components_47_map_47_map_46_service__ && $___46__46__47_app_47_components_47_map_47_map_46_service__.__esModule && $___46__46__47_app_47_components_47_map_47_map_46_service__ || {default: $___46__46__47_app_47_components_47_map_47_map_46_service__}).MapService;
	var MapDirective = ($___46__46__47_app_47_components_47_map_47_map_46_directive__ = __webpack_require__(14), $___46__46__47_app_47_components_47_map_47_map_46_directive__ && $___46__46__47_app_47_components_47_map_47_map_46_directive__.__esModule && $___46__46__47_app_47_components_47_map_47_map_46_directive__ || {default: $___46__46__47_app_47_components_47_map_47_map_46_directive__}).MapDirective;
	var RestrictionDirective = ($___46__46__47_app_47_components_47_restriction_47_restriction_46_directive__ = __webpack_require__(15), $___46__46__47_app_47_components_47_restriction_47_restriction_46_directive__ && $___46__46__47_app_47_components_47_restriction_47_restriction_46_directive__.__esModule && $___46__46__47_app_47_components_47_restriction_47_restriction_46_directive__ || {default: $___46__46__47_app_47_components_47_restriction_47_restriction_46_directive__}).RestrictionDirective;
	var NotificationsDirective = ($___46__46__47_app_47_components_47_notifications_47_notifications_46_directive__ = __webpack_require__(16), $___46__46__47_app_47_components_47_notifications_47_notifications_46_directive__ && $___46__46__47_app_47_components_47_notifications_47_notifications_46_directive__.__esModule && $___46__46__47_app_47_components_47_notifications_47_notifications_46_directive__ || {default: $___46__46__47_app_47_components_47_notifications_47_notifications_46_directive__}).NotificationsDirective;
	var LoadingDirective = ($___46__46__47_app_47_components_47_loading_47_loading_46_directive__ = __webpack_require__(17), $___46__46__47_app_47_components_47_loading_47_loading_46_directive__ && $___46__46__47_app_47_components_47_loading_47_loading_46_directive__.__esModule && $___46__46__47_app_47_components_47_loading_47_loading_46_directive__ || {default: $___46__46__47_app_47_components_47_loading_47_loading_46_directive__}).LoadingDirective;
	var SearchSwisstopoDirective = ($___46__46__47_app_47_components_47_search_47_searchSwisstopo_46_directive__ = __webpack_require__(18), $___46__46__47_app_47_components_47_search_47_searchSwisstopo_46_directive__ && $___46__46__47_app_47_components_47_search_47_searchSwisstopo_46_directive__.__esModule && $___46__46__47_app_47_components_47_search_47_searchSwisstopo_46_directive__ || {default: $___46__46__47_app_47_components_47_search_47_searchSwisstopo_46_directive__}).SearchSwisstopoDirective;
	var BackgroundImageDirective = ($___46__46__47_app_47_components_47_backgroundImage_47_backgroundImage_46_directive__ = __webpack_require__(19), $___46__46__47_app_47_components_47_backgroundImage_47_backgroundImage_46_directive__ && $___46__46__47_app_47_components_47_backgroundImage_47_backgroundImage_46_directive__.__esModule && $___46__46__47_app_47_components_47_backgroundImage_47_backgroundImage_46_directive__ || {default: $___46__46__47_app_47_components_47_backgroundImage_47_backgroundImage_46_directive__}).BackgroundImageDirective;
	var AutofocusDirective = ($___46__46__47_app_47_components_47_autofocus_47_autofocus_46_directive__ = __webpack_require__(20), $___46__46__47_app_47_components_47_autofocus_47_autofocus_46_directive__ && $___46__46__47_app_47_components_47_autofocus_47_autofocus_46_directive__.__esModule && $___46__46__47_app_47_components_47_autofocus_47_autofocus_46_directive__ || {default: $___46__46__47_app_47_components_47_autofocus_47_autofocus_46_directive__}).AutofocusDirective;
	angular.module('oerebAppV2', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'LocalStorageModule', 'toastr', 'base64', 'ngeo', 'siyfion.sfTypeahead', 'pascalprecht.translate', 'angular-carousel']).constant('moment', moment).config(config).config(routerConfig).run(runBlock).service('Coordinates', CoordinatesService).service('Helpers', HelpersService).service('Oereb', OerebBernService).service('Layers', LayersService).service('Extracts', ExtractsService).service('Notifications', NotificationsService).service('Loading', LoadingService).service('Map', MapService).controller('MainController', MainController).controller('DetailController', DetailController).directive('map', MapDirective).directive('notifications', NotificationsDirective).directive('loading', LoadingDirective).directive('search', SearchSwisstopoDirective).directive('autofocus', AutofocusDirective).directive('restriction', RestrictionDirective).directive('background', BackgroundImageDirective).filter('unique', function() {
	  return function(collection, keyname) {
	    var output = [],
	        keys = [];
	    angular.forEach(collection, function(item) {
	      var key = item[keyname];
	      if (keys.indexOf(key) === -1) {
	        keys.push(key);
	        output.push(item);
	      }
	    });
	    return output;
	  };
	});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	config.$inject = ["$logProvider", "toastrConfig", "$translateProvider", "localStorageServiceProvider"];
	Object.defineProperties(exports, {
	  config: {get: function() {
	      return config;
	    }},
	  __esModule: {value: true}
	});
	function config($logProvider, toastrConfig, $translateProvider, localStorageServiceProvider) {
	  'ngInject';
	  $logProvider.debugEnabled(true);
	  toastrConfig.allowHtml = true;
	  toastrConfig.timeOut = 3000;
	  toastrConfig.positionClass = 'toast-top-right';
	  toastrConfig.preventDuplicates = true;
	  toastrConfig.progressBar = true;
	  $translateProvider.useStaticFilesLoader({
	    prefix: '../app/lang/',
	    suffix: '.json'
	  });
	  $translateProvider.useSanitizeValueStrategy('escape');
	  $translateProvider.preferredLanguage('de');
	  localStorageServiceProvider.setPrefix('oerebApp');
	  localStorageServiceProvider.setStorageType('localStorage');
	}

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	routerConfig.$inject = ["$stateProvider", "$urlRouterProvider"];
	Object.defineProperties(exports, {
	  routerConfig: {get: function() {
	      return routerConfig;
	    }},
	  __esModule: {value: true}
	});
	function routerConfig($stateProvider, $urlRouterProvider) {
	  'ngInject';
	  $stateProvider.state('home', {
	    url: '/',
	    templateUrl: 'app/main/main.html',
	    controller: 'MainController',
	    controllerAs: 'main'
	  }).state('home.detail', {
	    url: 'd/:egrid?restriction',
	    params: {egrid: ''},
	    reloadOnSearch: false,
	    templateUrl: 'app/detail/detail.html',
	    controller: 'DetailController',
	    controllerAs: 'detail'
	  });
	  $urlRouterProvider.otherwise('/d/0');
	}

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	runBlock.$inject = ["$log"];
	Object.defineProperties(exports, {
	  runBlock: {get: function() {
	      return runBlock;
	    }},
	  __esModule: {value: true}
	});
	function runBlock($log) {
	  'ngInject';
	  $log.debug('runBlock end');
	}

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  MainController: {get: function() {
	      return MainController;
	    }},
	  __esModule: {value: true}
	});
	var MainController = function MainController($log, $translate, Extracts, Helpers, Map) {
	  'ngInject';
	  this.$translate = $translate;
	  this.Extracts = Extracts;
	  this.Map = Map;
	  this.Helpers = Helpers;
	  this.visibleContent = 'main';
	  angular.element(document).foundation();
	  var mainCtrl = this;
	  Extracts.registerCurrentObserverCallback(function() {
	    mainCtrl.extract = mainCtrl.Extracts.getCurrent();
	    mainCtrl.history = Extracts.get().slice().reverse();
	    console.log(mainCtrl.extract);
	  });
	  this.history = Extracts.get();
	};
	MainController.$inject = ["$log", "$translate", "Extracts", "Helpers", "Map"];
	($traceurRuntime.createClass)(MainController, {
	  setCurrentExtract: function(egrid) {
	    if (egrid != this.extract.egrid) {
	      this.Extracts.setCurrent(egrid);
	    }
	  },
	  changeLanguage: function(langKey) {
	    this.$translate.use(langKey);
	  },
	  isCurrentLanguage: function(langKey) {
	    return langKey == this.$translate.use();
	  },
	  toggleRestriction: function() {
	    this.isRestrictionOpen = !this.isRestrictionOpen;
	    if (this.isRestrictionOpen) {
	      this.Helpers.closeMenu();
	      this.Map.closeSearch();
	    }
	    return this.isRestrictionOpen;
	  },
	  showImprint: function() {
	    this.visibleContent = 'imprint';
	    this.Helpers.closeMenu();
	  },
	  showMain: function() {
	    this.visibleContent = 'main';
	    this.Helpers.openMenu();
	  },
	  showGlossary: function() {
	    this.visibleContent = 'glossary';
	    this.Helpers.closeMenu();
	  },
	  showThemes: function() {
	    this.visibleContent = 'themes';
	    this.Helpers.closeMenu();
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  DetailController: {get: function() {
	      return DetailController;
	    }},
	  __esModule: {value: true}
	});
	var DetailController = function DetailController($log, $translate, Extracts, Helpers, Map, Layers, $stateParams, $location, $scope, Coordinates) {
	  'ngInject';
	  var self = this;
	  this.Extracts = Extracts;
	  this.$location = $location;
	  this.Map = Map;
	  this.Layers = Layers;
	  this.Coordinates = Coordinates;
	  this.noDatas = true;
	  if ($stateParams.egrid == 0) {
	    this.noDatas = false;
	  } else {
	    this.addExtract($stateParams.egrid);
	  }
	  this.restrictionChanged(false);
	  $scope.$on('$locationChangeSuccess', function() {
	    self.restrictionChanged(true);
	  });
	  this.Extracts.registerRestrictionObserverCallback(function() {
	    console.log('execute register restriction observer');
	    self.tempLayers = [];
	    var bbox = '';
	    angular.forEach(self.Extracts.getRestriction().values, function(v) {
	      bbox = Helpers.getParameterByName('bbox', v.Map.ReferenceWMS);
	      var url = v.Map.ReferenceWMS.substr(0, v.Map.ReferenceWMS.indexOf('WMSServer?')) + 'WMSServer?';
	      var wmsTempSource = new self.Map.ol.source.TileWMS(({
	        url: url,
	        params: {
	          'LAYERS': Helpers.getParameterByName('LAYERS', v.Map.ReferenceWMS),
	          'TILED': true,
	          'VERSION': Helpers.getParameterByName('VERSION', v.Map.ReferenceWMS),
	          'FORMAT': Helpers.getParameterByName('FORMAT', v.Map.ReferenceWMS),
	          'CRS': Helpers.getParameterByName('CRS', v.Map.ReferenceWMS)
	        },
	        serverType: 'geoserver'
	      }));
	      var wmsTemp = new self.Map.ol.layer.Tile({
	        visible: true,
	        source: wmsTempSource,
	        name: 'restriction-temp'
	      });
	      self.tempLayers.push(wmsTemp);
	    });
	    self.Map.addTempLayers(self.tempLayers);
	  });
	  Extracts.registerCurrentObserverCallback(function() {
	    Helpers.openMenu();
	  });
	  angular.element('aside').foundation();
	  var $menuNav = angular.element('.menu-nav');
	  var $panel = angular.element('#menuLeftSlider');
	  if ($panel.attr('aria-expanded') == 'true') {
	    $log.debug('active');
	  }
	};
	DetailController.$inject = ["$log", "$translate", "Extracts", "Helpers", "Map", "Layers", "$stateParams", "$location", "$scope", "Coordinates"];
	($traceurRuntime.createClass)(DetailController, {
	  restrictionChanged: function(notify) {
	    if (angular.isUndefined(this.$location.search().restriction))
	      return;
	    this.Extracts.setRestrictionByCode(this.$location.search().restriction, notify);
	  },
	  isRestrictionActive: function(code) {
	    var restriction = this.Extracts.getRestriction();
	    if (restriction) {
	      return restriction.code == code;
	    }
	    return false;
	  },
	  addExtract: function(egrid) {
	    this.Extracts.add({egrid: egrid});
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  LayersService: {get: function() {
	      return LayersService;
	    }},
	  __esModule: {value: true}
	});
	var LayersService = function LayersService() {
	  'ngInject';
	  this.ol = ol;
	  this.Map = Map;
	  this.active = 'ortho';
	  this.layers = [];
	  this.resolutions = [4000, 3750, 3500, 3250, 3000, 2750, 2500, 2250, 2000, 1750, 1500, 1250, 1000, 750, 650, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1.5, 1, 0.5];
	  var extent = [2420000, 130000, 2900000, 1350000];
	  var projection = ol.proj.get('EPSG:2056');
	  projection.setExtent(extent);
	  var matrixIds = [];
	  for (var i = 0; i < this.resolutions.length; i++) {
	    matrixIds.push(i);
	  }
	  var self = this;
	  var wmtsSource = function(layerConfig) {
	    var resolutions = layerConfig.resolutions || self.resolutions;
	    var tileGrid = new ol.tilegrid.WMTS({
	      origin: [extent[0], extent[3]],
	      resolutions: resolutions,
	      matrixIds: matrixIds
	    });
	    var extension = layerConfig.format || 'png';
	    var timestamp = layerConfig['timestamps'][0];
	    return new ol.source.WMTS(({
	      url: '//wmts10.geo.admin.ch/1.0.0/{Layer}/default/' + timestamp + '/2056/{TileMatrix}/{TileCol}/{TileRow}.' + extension,
	      tileGrid: tileGrid,
	      projection: projection,
	      layer: layerConfig.serverLayerName,
	      requestEncoding: 'REST'
	    }));
	  };
	  var wmtsSat = new this.ol.layer.Tile({
	    name: 'aerial',
	    visible: false,
	    source: wmtsSource({
	      "format": "jpeg",
	      "serverLayerName": "ch.swisstopo.swissimage",
	      "label": "SWISSIMAGE",
	      "timestamps": ["20140620", "20131107", "20130916", "20130422", "20120809", "20120225", "20110914", "20110228"]
	    })
	  });
	  var wmtsOrtho = new this.ol.layer.Tile({
	    name: 'ortho',
	    visible: true,
	    source: wmtsSource({
	      "format": "jpeg",
	      "serverLayerName": "ch.swisstopo.pixelkarte-farbe",
	      "label": "SWISSIMAGE",
	      "timestamps": ["20140620", "20131107", "20130916", "20130422", "20120809", "20120225", "20110914", "20110228"]
	    })
	  });
	  var wmsOrtho = new ol.layer.Tile({
	    name: 'ortho',
	    visible: true,
	    source: new ol.source.TileWMS({
	      crossOrigin: 'anonymous',
	      params: {
	        'LAYERS': 'ch.swisstopo.pixelkarte-farbe-pk1000.noscale',
	        'FORMAT': 'image/jpeg'
	      },
	      url: 'http://wms.geo.admin.ch/'
	    })
	  });
	  var osmLayer = new this.ol.layer.Tile({
	    source: new this.ol.source.OSM(),
	    name: 'ortho'
	  });
	  this.wmsOerebSource = new this.ol.source.TileWMS(({
	    url: 'http://www.geoservice.apps.be.ch/geoservice/services/a42pub/a42pub_oereb_av_wms_d_bk_s/MapServer/WMSServer?',
	    params: {
	      'LAYERS': 'GEODB.AVR_BOF,GEODB.DIPANU_DIPANUF_SR,GEODB.DIPANU_DIPANUF_SR_B,GEODB.DIPANU_DIPANUF,GEODB.DIPANU_DIPANUF_B,GEODB.GRENZ5_G5_B,GEODB.TELEDAT_NW,GEODB.GEBADR_GADR,GEODB.AVR_PELE,GEODB.AVR_LELE,GEODB.AVR_FELE',
	      'TILED': true,
	      'VERSION': '1.3.0',
	      'FORMAT': 'image/png',
	      'CRS': 'EPSG:21781'
	    },
	    serverType: 'geoserver'
	  }));
	  var wmsOEREB = new this.ol.layer.Tile({
	    visible: true,
	    source: this.wmsOerebSource,
	    name: 'oereb'
	  });
	  wmsOEREB.setZIndex(100);
	  var oerebStatusSource = new this.ol.source.TileWMS(({
	    url: 'http://www.geoservice.apps.be.ch/geoservice/services/a42pub/a42pub_oereb_wms_d_fk_s/MapServer/WMSServer?',
	    params: {
	      'LAYERS': 'GEODB.OEREBST_OESTATUS',
	      'TILED': true,
	      'VERSION': '1.3.0',
	      'FORMAT': 'image/png',
	      'CRS': 'EPSG:21781'
	    },
	    serverType: 'geoserver'
	  }));
	  var wmsOEREBStatus = new this.ol.layer.Tile({
	    visible: true,
	    source: oerebStatusSource,
	    name: 'oereb'
	  });
	  this.add(osmLayer);
	  this.add(wmtsSat);
	  this.add(wmsOEREBStatus);
	  this.add(wmsOEREB);
	};
	($traceurRuntime.createClass)(LayersService, {
	  isActive: function(name) {
	    for (var i = 0; i < this.layers.length; i++) {
	      if (this.layers[i].M.name == name) {
	        return this.layers[i].visible;
	      }
	    }
	    return false;
	  },
	  hide: function(name) {
	    var inverse = arguments[1] !== (void 0) ? arguments[1] : false;
	    for (var i = 0; i < this.layers.length; i++) {
	      if (this.layers[i].M.name == name) {
	        this.layers[i].visible = inverse;
	      }
	    }
	    return name;
	  },
	  show: function(name) {
	    return this.hide(name, true);
	  },
	  get: function() {
	    var name = arguments[0] !== (void 0) ? arguments[0] : false;
	    if (angular.isString(name)) {
	      for (var i = 0; i < this.layers.length; i++) {
	        if (this.layers[i].M.name == name) {
	          return this.layers[i];
	        }
	      }
	    }
	    return this.layers;
	  },
	  add: function(layer) {
	    this.layers.push(layer);
	    console.log(this.layers);
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  OerebBernService: {get: function() {
	      return OerebBernService;
	    }},
	  __esModule: {value: true}
	});
	var OerebBernService = function OerebBernService($http, $log) {
	  'ngInject';
	  this.qnapOffline = false;
	  this.ssl = true;
	  this.$http = $http;
	  this.$log = $log;
	  this.base = 'http://adue03.myqnapcloud.com/oereb/OerbverSVC.svc/';
	  if (this.ssl) {
	    this.base = 'https://adue03.myqnapcloud.com/OerbverSVC.svc/';
	    this.base = 'https://adue03.novu.io/oereb/OerbverSVC.svc/';
	  }
	  this.reducedExtractPath = 'extract/reduced/xml/';
	  if (this.qnapOffline) {
	    this.base = 'https://oereb.plum.novu.ch/server/';
	    this.reducedExtractPath = 'reduced/';
	  }
	};
	OerebBernService.$inject = ["$http", "$log"];
	($traceurRuntime.createClass)(OerebBernService, {
	  getExtractById: function(egrid) {
	    var url = this.base + this.reducedExtractPath + egrid;
	    if (this.qnapOffline) {
	      url = this.base + this.reducedExtractPath + egrid + '.xml';
	    }
	    var promise = this.$http.get(url, {
	      cache: true,
	      transformResponse: function(data) {
	        var x2js = new X2JS();
	        var object = x2js.xml_str2json(data);
	        if (!angular.isObject(object))
	          return false;
	        if (angular.isDefined(object.GetExtractByIdResponse)) {
	          return object.GetExtractByIdResponse.Extract;
	        }
	        if (!object.GetEGRIDResponse) {
	          object.error = true;
	          return object;
	        }
	        return false;
	      }
	    });
	    return promise;
	  },
	  getEGRID: function(coordinates) {
	    var self = this;
	    var long = coordinates[4326][1];
	    var lat = coordinates[4326][0];
	    var url = this.base + 'getegrid/?GNSS=' + long + ',' + lat;
	    var promise = this.$http.get(url, {
	      cache: true,
	      transformResponse: function(data) {
	        var x2js = new X2JS();
	        var object = x2js.xml_str2json(data);
	        self.$log.info(object);
	        if (!object || !object.GetEGRIDResponse) {
	          return false;
	        }
	        if (angular.isArray(object.GetEGRIDResponse.egrid)) {
	          var results = [];
	          for (var i = 0; i < object.GetEGRIDResponse.egrid.length; i++) {
	            results[i] = {
	              'egrid': object.GetEGRIDResponse.egrid[i],
	              'number': object.GetEGRIDResponse.number[i]
	            };
	          }
	          return results;
	        }
	        return [{
	          'egrid': object.GetEGRIDResponse.egrid,
	          'number': object.GetEGRIDResponse.number
	        }];
	      }
	    });
	    return promise;
	  },
	  getDataFromWFS: function(coordinatesOrEGRID) {
	    if (angular.isString(coordinatesOrEGRID)) {
	      var egrid = coordinatesOrEGRID;
	      var geoserviceProxy = 'https://gs.novu.io/proxy/geoservice2/services/a42geo/a42geo_ortsangabenwfs_d_fk/MapServer/WFSServer?service=WFS&request=GetFeature&version=1.1.0&typename=a4p_a4p_ortsangabenwfs_d_fk_x:DIPANU_DIPANUF&Filter=%3Cogc:Filter%3E%3Cogc:PropertyIsEqualTo%20matchCase=%22true%22%20xmlns:ogc=%22http://www.opengis.net/ogc%22%3E%3Cogc:PropertyName%3EEGRID%3C/ogc:PropertyName%3E%3Cogc:Literal%3E' + egrid + '%3C/ogc:Literal%3E%3C/ogc:PropertyIsEqualTo%3E%3C/ogc:Filter%3E';
	    } else {
	      var long = coordinatesOrEGRID[2056][0];
	      var lat = coordinatesOrEGRID[2056][1];
	      var geoserviceProxy = 'https://gs.novu.io/proxy/geoservice2/services/a42geo/a42geo_ortsangabenwfs_d_fk/MapServer/WFSServer?service=WFS&request=GetFeature&version=1.1.0&typename=a4p_a4p_ortsangabenwfs_d_fk_x:DIPANU_DIPANUF&Filter=%3Cogc:Filter%3E%3Cogc:Contains%3E%3Cogc:PropertyName%3EShape%3C/ogc:PropertyName%3E%3Cgml:Point%20srsName=%22urn:x-ogc:def:crs:EPSG:2056%22%3E%3Cgml:pos%20srsName=%22urn:x-ogc:def:crs:EPSG:2056%22%3E' + long + '%20' + lat + '%3C/gml:pos%3E%3C/gml:Point%3E%3C/ogc:Contains%3E%3C/ogc:Filter%3E';
	    }
	    var self = this;
	    var promise = this.$http.get(geoserviceProxy, {transformResponse: function(data) {
	        var x2js = new X2JS();
	        var object = x2js.xml_str2json(data);
	        if (angular.isArray(object.FeatureCollection.featureMember)) {
	          return object.FeatureCollection.featureMember;
	        }
	        var dipanuf = object.FeatureCollection.featureMember;
	        return [dipanuf];
	      }});
	    return promise;
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  ExtractsService: {get: function() {
	      return ExtractsService;
	    }},
	  __esModule: {value: true}
	});
	var ExtractsService = function ExtractsService($log, $location, Loading, Oereb, Notifications, localStorageService, Helpers) {
	  'ngInject';
	  this.$log = $log;
	  this.Helpers = Helpers;
	  this.$location = $location;
	  this.Loading = Loading;
	  this.Oereb = Oereb;
	  this.Notifications = Notifications;
	  this.localStorageService = localStorageService;
	  this.extracts = [];
	  this.observers = [];
	  this.restrictionObservers = [];
	  var extractsFromStorage = localStorageService.get('extracts');
	  if (extractsFromStorage != null)
	    this.extracts = extractsFromStorage;
	};
	ExtractsService.$inject = ["$log", "$location", "Loading", "Oereb", "Notifications", "localStorageService", "Helpers"];
	($traceurRuntime.createClass)(ExtractsService, {
	  reset: function() {
	    this.extracts = [];
	  },
	  add: function(newExtract) {
	    var self = this;
	    this.remove(newExtract.egrid);
	    this.$log.warn('extract loading: ' + newExtract.egrid);
	    this.Loading.show();
	    newExtract.remove = function() {
	      self.remove(this.egrid);
	    };
	    this.Oereb.getExtractById(newExtract.egrid).then(function(d) {
	      newExtract = self.wrap(newExtract, d.data);
	      self.extracts.push(newExtract);
	      console.log(self.extracts.length);
	      while (self.extracts.length > 10)
	        self.extracts.shift();
	      self.setCurrent(newExtract.egrid);
	      self.localStorageService.set('extracts', self.extracts);
	      self.notifyCurrentObservers();
	      self.Loading.hide();
	      self.Notifications.add({
	        message: '{{ "notification_loadsuccess1" | translate }} ' + newExtract.data.RealEstate.Number + ' (' + newExtract.data.RealEstate.Municipality + ')' + ' {{ "notification_loadsuccess2" | translate}}',
	        type: 'success'
	      });
	      setTimeout(function() {
	        $('.notification-wrapper .success .notification-close').click();
	      }, 3000);
	    }).catch(function() {
	      self.Notifications.add({
	        message: '{{ "notification_failed1" | translate}} ' + newExtract.data.RealEstate.Number + ' (' + newExtract.data.RealEstate.Municipality + ')' + ' {{"notification_failed2" | translate }}',
	        type: 'alert'
	      });
	      self.Loading.hide();
	    });
	  },
	  wrap: function(newExtract, data) {
	    newExtract.data = data;
	    newExtract.themes = (data.ConcernedTheme instanceof Array) ? data.ConcernedTheme : [data.ConcernedTheme];
	    newExtract.ncthemes = (data.NotConcernedTheme instanceof Array) ? data.NotConcernedTheme : [data.NotConcernedTheme];
	    newExtract.wdthemes = (data.ThemeWithoutData instanceof Array) ? data.ThemeWithoutData : [data.ThemeWithoutData];
	    newExtract.layers = [];
	    var restrictions = [];
	    var count = 0;
	    angular.forEach(newExtract.data.RealEstate.RestrictionOnLandownership, function(d) {
	      if (angular.isUndefined(d.Theme))
	        return false;
	      var doesRestrictionTypeExist = false;
	      angular.forEach(restrictions, function(value, key) {
	        if (value.code == d.Theme.Code) {
	          value.values.push(d);
	          doesRestrictionTypeExist = true;
	        }
	      });
	      if (!doesRestrictionTypeExist) {
	        var theme = {};
	        theme.name = d.Theme.Name;
	        theme.code = d.Theme.Code;
	        theme.values = [];
	        theme.values.push(d);
	        theme.index = count++;
	        restrictions.push(theme);
	      }
	    });
	    newExtract.restrictions = restrictions;
	    newExtract.restrictionLength = Object.keys(restrictions).length;
	    return newExtract;
	  },
	  setCurrent: function(egrid) {
	    var self = this;
	    for (var i = 0; i < this.extracts.length; i++) {
	      if (this.extracts[i].egrid == egrid) {
	        self.currentExtract = self.extracts[i];
	        self.notifyCurrentObservers();
	      }
	    }
	  },
	  getCurrent: function() {
	    if (angular.isUndefined(this.currentExtract)) {
	      this.currentExtract = this.extracts[0];
	    }
	    return this.currentExtract;
	  },
	  registerCurrentObserverCallback: function(callback) {
	    this.observers.push(callback);
	  },
	  notifyCurrentObservers: function() {
	    angular.forEach(this.observers, function(callback) {
	      callback();
	    });
	    this.notifyRestrictionObservers();
	  },
	  setRestrictionByCode: function(code) {
	    var notify = arguments[1] !== (void 0) ? arguments[1] : true;
	    this.currentRestrictionChanged = true;
	    this.currentRestrictionCode = code;
	    this.$location.search('restriction', code);
	    if (notify)
	      this.notifyRestrictionObservers();
	  },
	  getRestrictionByCode: function() {
	    var result = false;
	    var self = this;
	    angular.forEach(this.getCurrent().restrictions, function(r) {
	      if (r.code == self.currentRestrictionCode) {
	        result = r;
	      }
	    });
	    if (!result)
	      this.Notifications.add({
	        message: '{{"notification_nothemeavailable" | translate }}',
	        type: 'warning'
	      });
	    return result;
	  },
	  getRestriction: function() {
	    if (this.currentRestrictionChanged) {
	      this.currentRestriction = this.getRestrictionByCode();
	      this.currentRestrictionChanged = false;
	    }
	    if (angular.isUndefined(this.currentRestriction) || this.currentRestriction == false) {
	      if (this.getCurrent().restrictions.length > 0)
	        this.currentRestriction = this.getCurrent().restrictions[0];
	      else
	        this.currentRestriction = false;
	    }
	    return this.currentRestriction;
	  },
	  registerRestrictionObserverCallback: function(callback) {
	    this.restrictionObservers.push(callback);
	  },
	  notifyRestrictionObservers: function() {
	    angular.forEach(this.restrictionObservers, function(callback) {
	      callback();
	    });
	  },
	  count: function() {
	    return this.extracts.length;
	  },
	  remove: function(egrid) {
	    var self = this;
	    for (var i = 0; i < this.extracts.length; i++) {
	      if (this.extracts[i].egrid == egrid) {
	        self.extracts.splice(i, 1);
	      }
	    }
	    this.$log.warn("animation: remove" + egrid);
	    return egrid;
	  },
	  get: function() {
	    return this.extracts;
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  NotificationsService: {get: function() {
	      return NotificationsService;
	    }},
	  __esModule: {value: true}
	});
	var NotificationsService = function NotificationsService($log) {
	  'ngInject';
	  this.$log = $log;
	  this.notifications = [];
	};
	NotificationsService.$inject = ["$log"];
	($traceurRuntime.createClass)(NotificationsService, {
	  reset: function() {
	    this.notifications = [];
	  },
	  add: function(notification) {
	    this.notifications.push(notification);
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  CoordinatesService: {get: function() {
	      return CoordinatesService;
	    }},
	  __esModule: {value: true}
	});
	var CoordinatesService = function CoordinatesService() {
	  'ngInject';
	  this.coordinates = {};
	  this.System = {
	    2056: {
	      'type': 2056,
	      'proj4': '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs'
	    },
	    4326: {
	      'type': 4326,
	      'proj4': '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'
	    },
	    21781: {
	      'type': 21781,
	      'proj4': '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs'
	    }
	  };
	};
	($traceurRuntime.createClass)(CoordinatesService, {
	  create: function(system, coordinates) {
	    var self = this;
	    var current = {};
	    var coordinates4326 = coordinates;
	    if (system != this.System[4326])
	      coordinates4326 = this.transform(coordinates, system, this.System[4326]);
	    current[4326] = coordinates4326;
	    angular.forEach(self.System, function(currentSystem) {
	      if (currentSystem != self.System[4326]) {
	        current[currentSystem.type] = self.transform(coordinates4326, self.System[4326], currentSystem);
	      }
	    });
	    return current;
	  },
	  set: function(name, system, coordinates) {
	    var self = this;
	    this.coordinates[name] = {};
	    var coordinates4326 = coordinates;
	    if (system != this.System[4326])
	      coordinates4326 = this.transform(coordinates, system, this.System[4326]);
	    self.coordinates[name][4326] = coordinates4326;
	    angular.forEach(self.System, function(currentSystem) {
	      if (currentSystem != self.System[4326]) {
	        self.coordinates[name][currentSystem.type] = self.transform(coordinates4326, self.System[4326], currentSystem);
	      }
	    });
	    return self.coordinates[name];
	  },
	  get: function(name, system) {
	    if (!(name in this.coordinates)) {
	      console.error('[cordinates] coordinate name doesn\'t exists');
	      return null;
	    }
	    if (system === undefined)
	      return this.coordinates[name];
	    if (!(system.type in this.coordinates[name])) {
	      console.error('[coordinates] system doesn\'t exists');
	      return null;
	    }
	    return this.coordinates[name][system.type];
	  },
	  transform: function(coordinates, systemFrom, systemTo) {
	    console.debug('transform:' + systemFrom.type + ' -> ' + systemTo.type);
	    return proj4(systemFrom.proj4, systemTo.proj4, coordinates);
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  LoadingService: {get: function() {
	      return LoadingService;
	    }},
	  __esModule: {value: true}
	});
	var LoadingService = function LoadingService() {
	  'ngInject';
	  this.hide();
	};
	($traceurRuntime.createClass)(LoadingService, {
	  show: function() {
	    this.visible = true;
	  },
	  hide: function() {
	    this.visible = false;
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  HelpersService: {get: function() {
	      return HelpersService;
	    }},
	  __esModule: {value: true}
	});
	var HelpersService = function HelpersService() {
	  'ngInject';
	};
	($traceurRuntime.createClass)(HelpersService, {
	  closeMenu: function() {
	    if (angular.element('#menuLeftSlider').attr('aria-expanded') == 'true')
	      $('#menuLeftSlider').foundation('toggle');
	  },
	  openMenu: function() {
	    if (angular.element('#menuLeftSlider').attr('aria-expanded') == 'false')
	      $('#menuLeftSlider').foundation('toggle');
	  },
	  getParameterByName: function(name, url) {
	    if (!url)
	      url = window.location.href;
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results)
	      return null;
	    if (!results[2])
	      return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	  },
	  getCenterOfBBBOX: function(bbox) {
	    var parts = bbox.split(',');
	    return [(parseFloat(parts[0]) + parseFloat(parts[2])) / 2, (parseFloat(parts[1]) + parseFloat(parts[3])) / 2];
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  MapService: {get: function() {
	      return MapService;
	    }},
	  __esModule: {value: true}
	});
	var MapService = function MapService(ngeoDecorateLayer, Layers, Oereb, Helpers, Coordinates) {
	  'ngInject';
	  var self = this;
	  this.ol = ol;
	  this.Oereb = Oereb;
	  this.Layers = Layers;
	  this.Coordinates = Coordinates;
	  this.Helpers = Helpers;
	  this.tempLayers = [];
	  this.selectedLayer = undefined;
	  this.clickObservers = [];
	  this.modeChangedObservers = [];
	  this.isSearchOpen = false;
	  this.config = {
	    zoom: {
	      default: 4,
	      zoomedIn: 13
	    },
	    projection: {
	      extent: [420000, 30000, 900000, 350000],
	      epsg: 'EPSG:21781'
	    }
	  };
	  this.center = [599042.5342280008, 185035.77279221092];
	  this.zoom = this.config.zoom.default;
	  Layers.get().forEach(function(layer) {
	    ngeoDecorateLayer(layer);
	  });
	  this.projection = this.ol.proj.get(self.config.projection.epsg);
	  this.view = new this.ol.View({
	    center: self.center,
	    zoom: self.zoom,
	    projection: this.projection
	  });
	  this.map = new this.ol.Map({
	    layers: Layers.get(),
	    view: this.view
	  });
	  var shouldUpdate = true;
	  var view = this.map.getView();
	  var onResizeMap = function() {
	    if (view.getZoom() > 11) {
	      self.Layers.show('oereb');
	    } else {
	      self.Layers.hide('oereb');
	    }
	    console.log(view.getZoom() + ' ' + view.getCenter());
	    return true;
	    if (!shouldUpdate) {
	      shouldUpdate = true;
	      return;
	    }
	    var center = view.getCenter();
	    var hash = '/#/?' + $base64.encode(view.getZoom() + '/' + center[0] + '/' + center[1]).slice(0, -1);
	    var state = {
	      zoom: view.getZoom(),
	      center: view.getCenter()
	    };
	    window.history.pushState(state, 'map', hash);
	  };
	  this.map.on('moveend', onResizeMap);
	  window.addEventListener('popstate', function(event) {
	    if (event.state === null) {
	      return;
	    }
	    self.map.getView().setCenter(event.state.center);
	    self.map.getView().setZoom(event.state.zoom);
	    shouldUpdate = false;
	  });
	  this.map.on('singleclick', function(event) {
	    var coordinates = self.Coordinates.set('lastClick', Coordinates.System[21781], event.coordinate);
	    self.notifyClickObservers(coordinates);
	  });
	  var positionFeatureStyle = new this.ol.style.Style({image: new this.ol.style.Circle({
	      radius: 6,
	      fill: new this.ol.style.Fill({color: 'rgba(230, 100, 100, 0)'}),
	      stroke: new this.ol.style.Stroke({
	        color: 'rgba(230, 40, 40, 1)',
	        width: 2
	      })
	    })});
	  var accuracyFeatureStyle = new this.ol.style.Style({
	    fill: new this.ol.style.Fill({color: 'rgba(100, 100, 230, 0.3)'}),
	    stroke: new this.ol.style.Stroke({
	      color: 'rgba(40, 40, 230, 1)',
	      width: 2
	    })
	  });
	  this.mobileGeolocationOptions = {
	    positionFeatureStyle: positionFeatureStyle,
	    accuracyFeatureStyle: accuracyFeatureStyle,
	    zoom: this.config.zoom.zoomedIn
	  };
	};
	MapService.$inject = ["ngeoDecorateLayer", "Layers", "Oereb", "Helpers", "Coordinates"];
	($traceurRuntime.createClass)(MapService, {
	  click: function(coordinates) {
	    this.notifyClickObservers(coordinates);
	  },
	  openSearch: function() {
	    this.Helpers.closeMenu();
	    this.isSearchOpen = true;
	    setTimeout(function() {
	      $('#search-me').trigger('focus');
	    }, 100);
	    return this.isSearchOpen;
	  },
	  closeSearch: function() {
	    this.isSearchOpen = false;
	    return this.isSearchOpen;
	  },
	  toggleSearch: function() {
	    if (this.isSearchOpen)
	      return this.closeSearch();
	    return this.openSearch();
	  },
	  setPosition: function(coordinates) {
	    var zoom = arguments[1] !== (void 0) ? arguments[1] : this.config.zoom.zoomedIn;
	    this.map.getView().setCenter([parseFloat(coordinates[21781][0]), parseFloat(coordinates[21781][1])]);
	    this.map.getView().setZoom(zoom);
	  },
	  setZoom: function(zoom) {
	    this.map.getView().setZoom(zoom);
	  },
	  addOverlay: function(overlay) {
	    this.map.addOverlay(overlay);
	  },
	  removeOverlay: function(overlay) {
	    this.map.removeOverlay(overlay);
	  },
	  zoomIn: function() {
	    var self = this;
	    self.map.getView().setZoom(self.map.getView().getZoom() + 1);
	  },
	  zoomOut: function() {
	    var self = this;
	    self.map.getView().setZoom(self.map.getView().getZoom() - 1);
	  },
	  getZoom: function() {
	    return self.map.getZoom();
	  },
	  registerClickObserver: function(callback) {
	    this.clickObservers.push(callback);
	  },
	  notifyClickObservers: function(coordinates) {
	    if (angular.element("#menuLeftSlider").attr('aria-expanded') == 'true') {
	      angular.element('#buttonShowExtract').click();
	    }
	    angular.forEach(this.clickObservers, function(callback) {
	      callback(coordinates);
	    });
	  },
	  addTempLayers: function(layers) {
	    var self = this;
	    angular.forEach(self.tempLayers, function(layer) {
	      self.map.removeLayer(layer);
	    });
	    self.tempLayers = [];
	    angular.forEach(layers, function(layer) {
	      self.tempLayers.push(layer);
	      self.addLayer(layer);
	    });
	  },
	  createPolygon: function(posList) {
	    var self = this;
	    var ring = [];
	    for (var i = 0; i < posList.length; i = i + 2) {
	      var temporary = self.Coordinates.create(self.Coordinates.System[2056], [posList[i], posList[i + 1]]);
	      ring.push([temporary[21781][0], temporary[21781][1]]);
	    }
	    return new self.ol.geom.Polygon([ring]);
	  },
	  addSelectedLayer: function(polygon) {
	    var self = this;
	    var feature = new self.ol.Feature(polygon);
	    var vectorSource = new self.ol.source.Vector();
	    vectorSource.addFeature(feature);
	    var vectorLayer = new self.ol.layer.Vector({
	      source: vectorSource,
	      style: new self.ol.style.Style({
	        stroke: new self.ol.style.Stroke({
	          color: 'rgba(255, 0, 0, 1.0)',
	          width: 2
	        }),
	        fill: new self.ol.style.Fill({color: 'rgba(255, 0, 0, 0)'})
	      })
	    });
	    vectorLayer.setZIndex(5000);
	    if (this.selectedLayer != undefined)
	      this.map.removeLayer(this.selectedLayer);
	    this.selectedLayer = vectorLayer;
	    this.addLayer(vectorLayer);
	  },
	  addLayer: function(layer) {
	    this.map.addLayer(layer);
	  },
	  get: function() {
	    return this.map;
	  },
	  getView: function() {
	    return this.map.getView();
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  MapDirective: {get: function() {
	      return MapDirective;
	    }},
	  __esModule: {value: true}
	});
	function MapDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/map/map.html',
	    controller: MapController,
	    controllerAs: 'map',
	    bindToController: true
	  };
	  return directive;
	}
	var MapController = function MapController(Layers, $log, $scope, $base64, $window, Oereb, Extracts, Map, Helpers, Coordinates) {
	  'ngInject';
	  this.$window = $window;
	  this.$log = $log;
	  this.$base64 = $base64;
	  this.Oereb = Oereb;
	  this.Extracts = Extracts;
	  this.Layers = Layers;
	  this.Map = Map;
	  this.Helpers = Helpers;
	  this.Coordinates = Coordinates;
	  var self = this;
	  Map.registerClickObserver(function(coordinates) {
	    self.Map.closeSearch();
	    if (self.Map.getView().getZoom() < 12) {
	      return;
	    }
	    var popup = new Map.ol.Overlay({element: document.getElementById('infobox')});
	    self.lastOverlay = popup;
	    Map.addOverlay(popup);
	    $('#object-information').hide();
	    var element = popup.getElement();
	    $(element).hide();
	    $(element).show();
	    popup.setPosition(coordinates[21781]);
	    self.selectedPoint = [];
	    self.infoboxLoading = true;
	    self.Oereb.getEGRID(coordinates).then(function(d) {
	      self.selectedPoint = d.data;
	      self.infoboxLoading = false;
	    });
	    self.Oereb.getDataFromWFS(coordinates).then(function(d) {
	      self.drawByWFS(d);
	    });
	  });
	  Extracts.registerCurrentObserverCallback(function() {
	    var egrid = self.Extracts.getCurrent().egrid;
	    self.Oereb.getDataFromWFS(egrid).then(function(d) {
	      var posList = self.getPoslistFromWFS(d);
	      var polygon = Map.createPolygon(posList);
	      self.drawByPolygon(polygon);
	      var size = Map.map.getSize();
	      Map.map.getView().fit(polygon, size, {
	        padding: [200, 200, 200, 200],
	        constrainResolution: false
	      });
	    });
	    Helpers.openMenu();
	  });
	  this.map = Map.map;
	  this.mobileGeolocationOptions = Map.mobileGeolocationOptions;
	};
	MapController.$inject = ["Layers", "$log", "$scope", "$base64", "$window", "Oereb", "Extracts", "Map", "Helpers", "Coordinates"];
	($traceurRuntime.createClass)(MapController, {
	  drawByWFS: function(d) {
	    var posList = this.getPoslistFromWFS(d);
	    var polygon = this.Map.createPolygon(posList);
	    this.Map.addSelectedLayer(polygon);
	  },
	  drawByPolygon: function(polygon) {
	    this.Map.addSelectedLayer(polygon);
	  },
	  getPoslistFromWFS: function(d) {
	    var posList = [];
	    angular.forEach(d.data, function(data) {
	      var cPosList = data.DIPANU_DIPANUF.SHAPE.MultiSurface.surfaceMember.Polygon.exterior.LinearRing.posList;
	      cPosList = cPosList.toString().split(" ");
	      angular.extend(posList, cPosList);
	    });
	    return posList;
	  },
	  restore: function() {
	    if (window.location.hash.indexOf('?') !== -1) {
	      var basedHash = window.location.hash.replace('#/?', '') + '=';
	      var hash = this.$base64.decode(basedHash);
	      var parts = hash.split('/');
	      if (parts.length === 3) {
	        this.zoom = parseInt(parts[0], 10);
	        this.center = [parseFloat(parts[1]), parseFloat(parts[2])];
	      }
	    }
	  },
	  getLocation: function() {
	    this.Helpers.closeMenu();
	  },
	  zoomIn: function() {
	    this.Map.zoomIn();
	    this.Helpers.closeMenu();
	  },
	  removeOverlay: function() {
	    if (angular.isDefined(this.lastOverlay))
	      return this.Map.removeOverlay(this.lastOverlay);
	    return false;
	    this.Helpers.closeMenu();
	  },
	  showOverlay: function() {
	    if (angular.isDefined(this.lastOverlay))
	      return this.Map.addOverlay(this.lastOverlay);
	    this.Helpers.closeMenu();
	  },
	  zoomOut: function() {
	    this.Map.zoomOut();
	    this.Helpers.closeMenu();
	  },
	  showLayer: function(name) {
	    if (name == 'ortho') {
	      this.Layers.show('ortho');
	      this.Layers.hide('aerial');
	    }
	    if (name == 'aerial') {
	      this.Layers.show('aerial');
	      this.Layers.hide('ortho');
	    }
	    this.Helpers.closeMenu();
	  },
	  isLayerActive: function(name) {
	    return this.Layers.isActive(name);
	  },
	  toggleSearch: function() {
	    this.Map.toggleSearch();
	    this.Helpers.closeMenu();
	  },
	  isSearchOpen: function() {
	    return this.Map.isSearchOpen;
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 15 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  RestrictionDirective: {get: function() {
	      return RestrictionDirective;
	    }},
	  __esModule: {value: true}
	});
	function RestrictionDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/restriction/restriction.html',
	    controller: RestrictionController,
	    controllerAs: 'restriction',
	    bindToController: true
	  };
	  return directive;
	}
	var RestrictionController = function RestrictionController($location, Extracts, $scope) {
	  'ngInject';
	  this.Extracts = Extracts;
	  this.$scope = $scope;
	  this.slideIndex = 0;
	  var self = this;
	  Extracts.registerRestrictionObserverCallback(function() {
	    self.slideIndex = self.Extracts.getRestriction().index;
	  });
	  $scope.$watch(function() {
	    return self.slideIndex;
	  }, function(value) {
	    self.setRestrictionByIndex();
	  });
	};
	RestrictionController.$inject = ["$location", "Extracts", "$scope"];
	($traceurRuntime.createClass)(RestrictionController, {
	  next: function() {
	    this.slideIndex = this.slideIndex + 1;
	    this.setRestrictionByIndex();
	  },
	  back: function() {
	    this.slideIndex = this.slideIndex - 1;
	    this.setRestrictionByIndex();
	  },
	  setRestrictionByIndex: function() {
	    if (angular.isUndefined(this.Extracts.getCurrent()))
	      return false;
	    var restrictions = this.Extracts.getCurrent().restrictions;
	    if (restrictions && restrictions.length > 0)
	      this.Extracts.setRestrictionByCode(restrictions[this.slideIndex].code, false);
	    else
	      return false;
	    return true;
	  }
	}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  NotificationsDirective: {get: function() {
	      return NotificationsDirective;
	    }},
	  __esModule: {value: true}
	});
	function NotificationsDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/notifications/notifications.html',
	    controller: NotificationsController,
	    controllerAs: 'notifications',
	    bindToController: true
	  };
	  return directive;
	}
	var NotificationsController = function NotificationsController(Notifications) {
	  'ngInject';
	  this.elements = Notifications.notifications;
	};
	NotificationsController.$inject = ["Notifications"];
	($traceurRuntime.createClass)(NotificationsController, {}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  LoadingDirective: {get: function() {
	      return LoadingDirective;
	    }},
	  __esModule: {value: true}
	});
	function LoadingDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/loading/loading.html',
	    controller: LoadingController,
	    controllerAs: 'loading',
	    bindToController: true
	  };
	  return directive;
	}
	var LoadingController = function LoadingController(Loading) {
	  'ngInject';
	  this.Loading = Loading;
	};
	LoadingController.$inject = ["Loading"];
	($traceurRuntime.createClass)(LoadingController, {visible: function() {
	    return this.Loading.visible;
	  }}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  SearchSwisstopoDirective: {get: function() {
	      return SearchSwisstopoDirective;
	    }},
	  __esModule: {value: true}
	});
	function SearchSwisstopoDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/search/search.html',
	    controller: SearchSwisstopoController,
	    controllerAs: 'search',
	    bindToController: true
	  };
	  return directive;
	}
	var SearchSwisstopoController = function SearchSwisstopoController($scope, Map, Coordinates) {
	  'ngInject';
	  this.Map = Map;
	  var self = this;
	  var placesSource = new Bloodhound({
	    limit: 30,
	    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
	    queryTokenizer: Bloodhound.tokenizers.whitespace,
	    remote: {
	      url: 'https://api3.geo.admin.ch/rest/services/api/SearchServer?searchText=%QUERY&type=locations',
	      wildcard: '%QUERY',
	      filter: function(locations) {
	        return locations.results;
	      }
	    }
	  });
	  placesSource.initialize();
	  this.places = {
	    displayKey: function(location) {
	      var returnLocation = location.attrs.label.replace('<b>', '').replace('</b>', '');
	      returnLocation = returnLocation.replace('<i>', '').replace('</i>', '');
	      return returnLocation;
	    },
	    source: placesSource.ttAdapter()
	  };
	  $scope.$watch(function() {
	    return self.search;
	  }, function(value) {
	    if (self.search !== null && typeof self.search === 'object') {
	      var coordinates = Coordinates.set('search', Coordinates.System[4326], [self.search.attrs.lon, self.search.attrs.lat]);
	      self.Map.setPosition(coordinates);
	      self.Map.click(coordinates);
	    }
	  });
	};
	SearchSwisstopoController.$inject = ["$scope", "Map", "Coordinates"];
	($traceurRuntime.createClass)(SearchSwisstopoController, {}, {});

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  BackgroundImageDirective: {get: function() {
	      return BackgroundImageDirective;
	    }},
	  __esModule: {value: true}
	});
	function BackgroundImageDirective() {
	  'ngInject';
	  return function(scope, element, attrs) {
	    var url = attrs.background;
	    element.css({'background-image': 'url(' + url + ')'});
	  };
	}

	//# sourceMappingURL=<compileOutput>


/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperties(exports, {
	  AutofocusDirective: {get: function() {
	      return AutofocusDirective;
	    }},
	  __esModule: {value: true}
	});
	function AutofocusDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'A',
	    link: function($scope, $element) {
	      console.log('autofocus directive executed');
	      $timeout(function() {
	        $element[0].focus();
	      });
	    }
	  };
	  return directive;
	}

	//# sourceMappingURL=<compileOutput>


/***/ }
/******/ ]);
angular.module("oerebAppV2").run(["$templateCache", function($templateCache) {$templateCache.put("app/detail/detail.html","<aside id=menuLeftSlider data-toggler data-animate=\"slide-in-left slide-out-left\" class=\"position-left ease-in-out\"><nav id=mainNav class=\"mainnav mobile clearfix\"><div class=\"row top-menu\"><div class=\"small-9 lang-selector\"><svg class=\"icon icon-globe\"><use xlink:href=#icon-globe></use></svg> <span ng-click=\"main.changeLanguage(\'de\')\"><a title=\"Deutsche Version\" ng-class=\"{\'is-active\': main.isCurrentLanguage(\'de\')}\">Deutsch</a> </span><span><a ng-click=\"main.changeLanguage(\'fr\')\" title=\"Version française\" ng-class=\"{\'is-active\': main.isCurrentLanguage(\'fr\')}\">Français</a></span></div></div><ul data-accordion-menu class=\"menu vertical\"><div ng-class=\"{\'hidden\': detail.noDatas}\" class=no-property><p class=hint>{{ \'no_property_loaded\' | translate }}</p></div><h1>{{\"mainTitle\" | translate}}</h1><li ng-class=\"{\'hidden\': !detail.noDatas}\" class=\"top-item accordion-navigation\"><a href=\"\"><button class=\"button submenu svg-icon\"><svg class=\"icon icon-plus\"><use xlink:href=#icon-plus></use></svg> <svg class=\"icon icon-minus\"><use xlink:href=#icon-minus></use></svg></button><p class=name>{{\"detailProperty\" | translate}} {{main.extract.data.RealEstate.Number}} ({{main.extract.data.RealEstate.Municipality}})</p><ul class=\"menu vertical nested\"><li><div class=\"row property-info\"><div class=\"medium-4 oereb-label\">{{\"detailRealEstateNr\" | translate}}</div><div class=medium-1></div><div class=\"medium-7 oereb-value\">{{main.extract.data.RealEstate.Number}}</div></div><div class=\"row property-info\"><div class=\"medium-4 oereb-label\">{{\"detailEGRID\" | translate}}</div><div class=medium-1></div><div class=\"medium-7 oereb-value\">{{main.extract.egrid}}</div></div><div class=\"row property-info\"><div class=\"medium-4 oereb-label\">{{\"detailCommunityBFS\" | translate}}</div><div class=medium-1></div><div class=\"medium-7 oereb-value\">{{main.extract.data.RealEstate.Municipality}} ({{main.extract.data.RealEstate.FosNr}})</div></div><div class=\"row property-info\"><div class=\"medium-4 oereb-label\">{{\"detailSubUnitOfLandRegister\" | translate}}</div><div class=medium-1></div><div class=\"medium-7 oereb-value\">{{main.extract.data.RealEstate.SubunitofLandRegister}}</div></div><div class=\"row property-info\"><div class=\"medium-4 oereb-label\">{{\"detailRealEstateArea\" | translate}}</div><div class=medium-1></div><div class=\"medium-7 oereb-value\">{{main.extract.data.RealEstate.LandRegistryArea}} m<sup>2</sup></div></div><div class=\"row property-info\"><div class=\"medium-4 oereb-label\">{{\"detailExtractIdentifier\" | translate}}</div><div class=medium-1></div><div class=\"medium-7 oereb-value\">{{main.extract.data.ExtractIdentifier}}</div></div><div class=\"row property-info\"><div class=\"medium-4 oereb-label\">{{\"detailExtractDate\" | translate}}</div><div class=medium-1></div><div class=\"medium-7 oereb-value\">{{main.extract.data.CreationDate | date:\'dd.MM.yyyy HH:mm:ss\'}}</div></div><div class=\"row property-info\"><div class=\"medium-4 oereb-label\">{{\"detailResponsible\" | translate}}</div><div class=medium-1></div><div class=\"medium-7 oereb-value\">{{main.extract.data.PLRCadastreAuthority.Name.LocalisedText.Text}}, {{main.extract.data.PLRCadastreAuthority.Street}}&nbsp;{{main.extract.data.PLRCadastreAuthority.Number}}, {{main.extract.data.PLRCadastreAuthority.PostalCode}}&nbsp;{{main.extract.data.PLRCadastreAuthority.City}}</div></div><div class=\"row more-info clearfix pdf-download\"><div class=small-12><svg class=\"icon icon-file\"><use xlink:href=#icon-file></use></svg> <a class=external-link href=http://adue03.myqnapcloud.com/oereb/OerbverSVC.svc/extract/reduced/pdf/{{main.extract.egrid}} title=\'{{\"detailDownloadPDF\" | translate}}\'>{{\"detailDownloadPDF\" | translate}} ({{\"detailDownloadPDFExt\" | translate}})</a></div></div><div class=\"row more-info clearfix\"><div class=small-12><svg class=\"icon icon-map\"><use xlink:href=#icon-map></use></svg> <a class=external-link href=# title=\"{{\'detailPropertyGISMap\' | translate}}\">{{\"detailPropertyGISMap\" | translate}} (Noch nicht implementiert)</a></div></div></li></ul></a></li><li ng-class=\"{\'hidden\': !detail.noDatas}\" class=accordion-navigation><a href=\"\"><button class=\"button submenu svg-icon\"><svg class=\"icon icon-plus\"><use xlink:href=#icon-plus></use></svg> <svg class=\"icon icon-minus\"><use xlink:href=#icon-minus></use></svg></button> {{\"detailConcernedThemes1\" | translate}}{{main.extract.data.RealEstate.Number}} {{\"detailConcernedThemes2\" | translate}} {{main.extract.data.RealEstate.Municipality}} {{\"detailConcernedThemes3\" | translate}}</a><ul class=\"menu vertical nested is-active\"><li ng-repeat=\"theme in main.extract.themes track by $index\"><a ui-sref=\"home.detail({restriction: theme.Code})\">{{theme.Name}} <span ng-class=\"{\'current\': detail.isRestrictionActive(theme.Code)}\" class=\"badge float-right\">&nbsp;</span></a></li></ul></li><li ng-class=\"{\'hidden\': !detail.noDatas}\" class=accordion-navigation><a href=\"\"><button class=\"button submenu svg-icon\"><svg class=\"icon icon-plus\"><use xlink:href=#icon-plus></use></svg> <svg class=\"icon icon-minus\"><use xlink:href=#icon-minus></use></svg></button> {{\"detailNoRestrictions\" | translate}}</a><ul class=\"menu vertical nested\"><li ng-repeat=\"theme in main.extract.ncthemes track by $index\">{{theme.Name}}</li></ul></li><li ng-class=\"{\'hidden\': !detail.noDatas}\" class=accordion-navigation><a href=\"\"><button class=\"button submenu svg-icon\"><svg class=\"icon icon-plus\"><use xlink:href=#icon-plus></use></svg> <svg class=\"icon icon-minus\"><use xlink:href=#icon-minus></use></svg></button> {{\"detailMissingRestrictions\" | translate}}</a><ul class=\"menu vertical nested\"><li ng-repeat=\"theme in main.extract.wdthemes track by $index\">{{theme.Name}}</li></ul></li><li ng-class=\"{\'hidden\': !main.history.length}\" class=\"accordion-navigation history-item\"><a href=\"\"><button class=\"button submenu svg-icon\"><svg class=\"icon icon-plus\"><use xlink:href=#icon-plus></use></svg> <svg class=\"icon icon-minus\"><use xlink:href=#icon-minus></use></svg></button> {{\"detailPropertyHistory\" | translate}} <span class=\"secondary badge\">{{main.history.length}}</span></a><ul class=\"menu vertical-nested\"><li ng-repeat=\"hextract in main.history track by $index\"><a ui-sref=\"home.detail({egrid: hextract.egrid, restriction: \'\'})\" title=\"Link auf Liegenschaft Nr. {{hextract.data.RealEstate.Number}}, Gemeinde {{hextract.data.RealEstate.Municipality}}\"><div ng-style=\"{\'background-image\': \'url(\' + hextract.data.MunicipalityLogo + \')\'}\" class=logo-gemeinde></div>Liegenschaft Nr. {{hextract.data.RealEstate.Number}}, Gemeinde {{hextract.data.RealEstate.Municipality}} ({{hextract.data.RealEstate.FosNr}})<span class=history-date>{{main.extract.data.CreationDate | date:\'dd.MM.yyyy HH:mm:ss\'}}</span></a></li><li><a href=# class=copy-clipboard><svg class=\"icon icon-inbox listicon\"><use xlink:href=#icon-inbox></use></svg> Grundstücke in die Zwischenablage kopieren</a></li></ul></li><li><a ng-click=main.showThemes()>Themenbereiche</a></li><li><a ng-click=main.showGlossary()>Glossar</a></li><li><a ng-click=main.showImprint()>Rechtliches und Impressum</a></li></ul></nav></aside>");
$templateCache.put("app/main/main.html","<p class=show-for-sr><a href=#mainContent class=show-on-focus>{{ \'jump_content\' | translate }}</a> <a href=#mainNav class=show-on-focus>{{ \'jump_menu\' | translate }}</a></p><div id=site-container class=site-wrapper><div class=wrapper-inner><div ui-view></div><div class=content-wrapper><header class=header><div data-sticky-container class=header-sticky-container><div data-sticky data-anchor=site-container data-sticky-on=small data-margin-top=0 class=header-sticky><!-- [bs][todo] Wie könnte man den Link so formulieren, dass quasi eine Default-Ansicht generiert würde (ein Home ohne geladenes Grundstück)? Also: man klickt auf Home und es gibt einen Reset.\r\n                      --> <a href=/# title=\"Zum Eingang\" class=mainlogo><img src=/assets/images/logo_dot_oereb.svg title=\"OEREB Logo\"><p><span class=oereb-title>{{\'title\'|translate}}</span><span class=show-for-medium>{{ \'subtitle\' | translate }}</span></p></a><div class=menu-nav><button id=buttonShowExtract data-toggle=menuLeftSlider aria-controls=menuLeftSlider class=\"button svg-icon btnOpenMenu\"><svg class=\"icon icon-menu\"><use xlink:href=#icon-menu></use></svg></button></div><div ng-class=\"{\'hidden\': main.extract}\" class=\"no-property show-for-medium header-title\"><h2 class=hint>{{ \'no_property_loaded\' | translate }}</h2></div><div ng-class=\"{\'hidden\': !main.extract}\" class=\"show-for-medium header-title\"><h2>{{\"detailProperty\" | translate}} {{main.extract.data.RealEstate.Number}} ({{main.extract.data.RealEstate.Municipality}})</h2></div><div class=header-logo><div ng-if=main.extract.data.MunicipalityLogo style=\"background-image:url(\'{{main.extract.data.MunicipalityLogo}}\')\" class=logo-gemeinde></div><div ng-if=!main.extract.data.MunicipalityLogo style=\"background-image:url(\'/assets/images/gde_dummy.png\')\" class=logo-gemeinde></div><div style=\"background-image:url(\'/assets/images/kanton_be.png\')\" class=logo-kanton></div><div style=\"background-image:url(\'/assets/images/bund_wappen.png\')\" class=logo-bund></div></div></div></div></header><article class=article><div class=row><div class=small-12><map ng-class=\"{\'hidden\': main.visibleContent != \'main\'}\"></map></div></div><restriction class=\"animated pulse\" ng-show=\"main.extract.restrictionLength > 0\" ng-class=\"{\'opened animated slideInUp\': main.isRestrictionOpen}\"></restriction><!-- *********** START CONTENT PAGE SECTIONS *********** --><!-- CONTENT: Impressum --><section class=\"contentpage contentimpressum\" ng-class=\"{\'current\': main.visibleContent == \'imprint\'}\"><div class=row><div class=\"columns small-12\"><h1>Impressum und Rechtliches (<a ng-click=main.showMain()>Close</a>)</h1><h2>Impressum</h2><h3>Inhaltliche Verantwortung</h3><address>Bau-, Verkehrs- und Energiedirektion des Kantons Bern</address><h3>Usability</h3><address>uFive</address><h3>Gestaltung und Screendesign</h3><address>Sturm und Bräm GmbH</address><h3>Technische Realisierung</h3><address>novu GmbH</address><h2>Rechtliches</h2><p>Teile dieser Applikation unterliegen den folgenden Lizenzen</p></div></div></section><!-- END CONTENT: Impressum --><!-- CONTENT: Glossary --><section class=\"contentpage contentglossary\" ng-class=\"{\'current\': main.visibleContent == \'glossary\'}\"><div class=row><div class=\"columns small-12\"><h1>{{\"contentTitleGlossary\" | translate}} (<a ng-click=main.showMain()>Close</a>)</h1><!-- [bs][todo] Das Glossar kommt aus diesem XML-Node: Glossary:Title und muss entsprechend repetiert werden --><dl ng-repeat=\"element in main.extract.data.Glossary\"><dt>{{element.Title.LocalisedText.Text}}</dt><dd>{{element.Content.LocalisedText.Text}}</dd></dl><dl><dt>ÖREB-Kataster</dt><dd>Öffentlich-rechtliche Eigentumsbeschränkungen: siehe auch <a href=http://www.cadastre.ch class=external-link>www.cadastre.ch</a></dd></dl></div></div></section><!-- END CONTENT: Glossary --><!-- CONTENT: Themenbereiche --><section class=\"contentpage contentthemes\" ng-class=\"{\'current\': main.visibleContent == \'themes\'}\"><div class=row><div class=\"columns small-12\">Themenbereiche (<a ng-click=main.showMain()>Close</a>)</div></div></section><!-- END CONTENT: Themenbereiche --><!-- CONTENT: Other content --><section class=\"contentpage contentinfo\" ng-class=\"{\'current\': main.visibleContent == \'other\'}\"><div class=row><div class=\"columns small-12\"><h1>Was ist die ÖREB?</h1><p>Wer in der Schweiz Land besitzt, kann dieses nicht einfach so nutzen, wie er will. Es gilt Rahmenbedingungen einzuhalten, die aufgrund von Entscheidungen des Gesetzgebers oder der Behörden entstanden sind. Diese sogenannten öffentlich-rechtlichen Eigentumsbeschränkungen (kurz ÖREB) sind für Grundeigentümerinnen und Grundeigentümer verpflichtend.</p><p>Mit dem sich im Aufbau befindenden Kataster der öffentlich-rechtlichen Eigentumsbeschränkungen (ÖREB-Kataster) werden relevante Informationen über Grundstücke leicht verfügbar. Zudem wird die Rechtssicherheit dank verbindlicher Informationen erhöht. Davon profitieren sowohl Grundstückbesitzer, als auch die verschiedenen Akteure des Immobilienmarktes, Behörden und öffentliche Verwaltungen.</p></div></div></section><!-- END CONTENT: Other content --><!-- *********** END CONTENT PAGE SECTIONS *********** --></article><footer class=footer></footer><notifications></notifications><loading></loading></div></div></div>");
$templateCache.put("app/components/loading/loading.html","<div ng-show=loading.visible() class=spinner-wrapper><div class=spinner><div class=double-bounce1></div><div class=double-bounce2></div></div><div class=\"sk-circle hide-todo\"><div class=\"sk-circle1 sk-child\"></div><div class=\"sk-circle2 sk-child\"></div><div class=\"sk-circle3 sk-child\"></div><div class=\"sk-circle4 sk-child\"></div><div class=\"sk-circle5 sk-child\"></div><div class=\"sk-circle6 sk-child\"></div><div class=\"sk-circle7 sk-child\"></div><div class=\"sk-circle8 sk-child\"></div><div class=\"sk-circle9 sk-child\"></div><div class=\"sk-circle10 sk-child\"></div><div class=\"sk-circle11 sk-child\"></div><div class=\"sk-circle12 sk-child\"></div></div></div>");
$templateCache.put("app/components/map/map.html","<div id=map class=map ngeo-map=map.map></div><div class=infobox id=infobox><div class=oereb-marker><img src=assets/images/oereb_marker.svg alt=\"Markiertes Grundstück\"></div><div ng-if=infoboxLoading>{{\'infobox_loading\' | translate}}</div><div ng-if=!infoboxLoading><strong>{{ \'infobox_property\' | translate }}</strong><div ng-if=\"map.egrids.length == 0\">{{\'no_propery_found\' | translate}}</div><ul><li ng-repeat=\"ele in map.selectedPoint\"><!-- [bs][todo] zusätzlich noch die grundstückart angeben, wenn irgendwie möglich --> <span class=clickable href=# ui-sref=\"home.detail({egrid: ele.egrid, restriction: null})\">{{\'infobox_plot\' | translate}} {{ele.number}}</span></li></ul></div></div><div class=map-nav ngeo-recenter ngeo-recenter-map=::map.map><button class=\"button svg-icon btnSearch\" ng-click=map.toggleSearch()><svg class=\"icon icon-search\"><use xlink:href=#icon-search></use></svg></button><search></search><button class=\"button svg-icon btnGetLocation\" ngeo-mobile-geolocation=map.map ngeo-mobile-geolocation-map=map.map ngeo-mobile-geolocation-options=map.mobileGeolocationOptions ng-click=map.getLocation()><svg class=\"icon icon-location-2\"><use xlink:href=#icon-location-2></use></svg></button> <button ng-click=map.zoomIn() class=\"button svg-icon btnZoomIn hide-for-small-only\"><svg class=\"icon icon-plus\"><use xlink:href=#icon-plus></use></svg></button> <button ng-click=map.zoomOut() type=button class=\"button svg-icon btnZoomOut hide-for-small-only\"><svg class=\"icon icon-minus\"><use xlink:href=#icon-minus></use></svg></button> <button class=\"button svg-icon btnMapAerial\" ng-click=\"map.showLayer(\'aerial\')\" ng-show=\"!map.isLayerActive(\'aerial\')\"><svg class=\"icon icon-aerial\"><use xlink:href=#icon-aerial></use></svg></button> <button class=\"button svg-icon btnMapOrtho\" ng-click=\"map.showLayer(\'ortho\')\" ng-show=\"!map.isLayerActive(\'ortho\')\"><svg class=\"icon icon-map\"><use xlink:href=#icon-map></use></svg></button></div>");
$templateCache.put("app/components/notifications/notifications.html","<div class=notification-wrapper><div ng-repeat=\"element in notifications.elements\" data-closable=\"scale-out-down fast\" class=callout ng-class=element.type><p>{{element.message | translate}}</p><button type=button role=button aria-label=\"{{\'notification_close\' | translate}}\" data-close class=\"button svg-icon notification-close\"><svg class=\"icon icon-cross\"><use xlink:href=#icon-cross></use></svg></button> <button ng-repeat=\"button in element.buttons\" type=button role=button aria-label=Ja data-close ng-click=button.callback() class=\"button svg-icon success notification-button hollow\">{{button.label | translate}}</button></div></div>");
$templateCache.put("app/components/restriction/restriction.html","<ul class=restriction-carousel rn-carousel rn-carousel-control rn-carousel-index=restriction.slideIndex><div class=sticky-carousel-header><h3 class=\"text-center slide-title\">{{main.extract.data.ConcernedTheme[restriction.slideIndex].Name}}</h3></div><li class=restriction-container ng-repeat=\"r in main.extract.restrictions\"><!-- [bs][todo] Indicators für die Slides einbauen. Ich habe das von https://github.com/revolunet/angular-carousel eventuell habe ich es nicht richtig eingebaut --><div class=slide-indicators rn-carousel-indicators ng-if=\"slides.length > 1\" slides=\"r in main.extract.restrictions\" rn-carousel-index=carouselIndex></div><div class=\"row theme-key\"><h3>{{\"restrictionConcernedKey\" | translate}}</h3></div><div ng-repeat=\"v in r.values\" class=accordion-navigation><div class=\"row restriction-info\"><div class=\"small-1 oereb-label\"><div class=legend-symbol style=\"background-image:url(\'{{v.Symbol}}\')\"></div></div><div class=\"small-11 medium-7 oereb-value\">{{v.Information.LocalisedText.Text}}</div><div class=\"small-1 show-for-small-only\"></div><div ng-if=\"v.TypeCodelist == \'Polygon\'\" class=\"small-11 medium-4 oereb-area\">{{v.Area}}m² ({{v.PartInPercent}}%)</div><div ng-if=\"v.TypeCodelist == \'Polyline\'\" class=\"small-11 medium-4 oereb-area\">{{v.Area}}m</div><div ng-if=\"v.TypeCodelist == \'Point\'\" class=\"small-11 medium-4 oereb-area\">{{v.Area}} Anzahl</div></div></div><!-- Legende als externer Link --><div class=\"row more-info\"><div class=small-12><svg class=\"icon icon-layers\"><use xlink:href=#icon-layers></use></svg> <a class=external-link href={{r.values[0].Map.LegendAtWeb}} title=\"{{\'restrictionKeyDownload\' | translate}}\">{{\"restrictionKeyDownload\" | translate}} ({{r.name}})</a></div></div><div class=row><h3 class=theme-heading>{{\"restrictionLegalProvision\" | translate }}</h3></div><div ng-repeat=\"v in r.values\" class=accordion-navigation><div ng-repeat=\"document in v.LegalProvisions | unique:\'document.TextAtWeb.LocalisedText.Text\'\" class=\"row more-info pdf-list\"><div class=small-12><svg class=\"icon icon-file\"><use xlink:href=#icon-file></use></svg> <a class=external-link target=_blank href={{document.TextAtWeb.LocalisedText.Text}} title=PDF>{{document.OfficialTitle.LocalisedText.Text}}</a></div></div></div><div class=row><h3 class=theme-heading>{{\"restrictionAuthority\" | translate}}</h3></div><div class=\"row more-info pdf-list\"><div class=small-12><svg class=\"icon icon-open\"><use xlink:href=#icon-open></use></svg> <a class=external-link target=_blank href={{r.values[0].LegalProvisions[0].ResponsibleOffice.Name.LocalisedText.Text}} title=Link>{{r.values[0].LegalProvisions[0].ResponsibleOffice.Name.LocalisedText.Text}}</a></div></div></li></ul><button ng-click=restriction.back() ng-show=\"restriction.slideIndex > 0\" id=themePrev class=\"orbit-previous svg-icon\"><svg class=\"icon icon-keyboard_arrow_left\"><use xlink:href=#icon-keyboard_arrow_left></use></svg></button> <button ng-click=restriction.next() ng-show=\"restriction.slideIndex < main.extract.restrictionLength - 1\" id=themeNext class=\"orbit-next svg-icon\"><svg class=\"icon icon-keyboard_arrow_right\"><use xlink:href=#icon-keyboard_arrow_right></use></svg></button> <button class=\"button svg-icon restriction-toggler\" ng-click=main.toggleRestriction()><svg class=\"icon icon-keyboard_arrow_up\"><use xlink:href=#icon-keyboard_arrow_up></use></svg></button>");
$templateCache.put("app/components/search/search.html","<div ng-show=map.isSearchOpen() class=\"search-input search-open\"><input type=text id=search-me class=\"typeahead searchbox\" sf-typeahead datasets=search.places ng-model=search.search name=search_input> <button class=\"button svg-icon delete-search\" ng-click=\"search.search = \'\'\"><svg class=\"icon icon-cross\"><use xlink:href=#icon-cross></use></svg></button></div>");}]);